var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 94,
    viewBox: "0 0 97 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 93.7853,
    rx: 10,
    fill: "#448CB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.2429 29.8747L64.5037 38.7153C65.461 39.3535 65.7197 40.647 65.0815 41.6043C64.9289 41.8332 64.7325 42.0296 64.5037 42.1821L51.2429 51.0227C49.4934 52.189 47.2142 52.189 45.4648 51.0227L32.204 42.1821C31.2466 41.5439 30.9879 40.2504 31.6262 39.2931C31.7787 39.0642 31.9751 38.8678 32.204 38.7153L45.4648 29.8747C47.2142 28.7084 49.4934 28.7084 51.2429 29.8747ZM65.0739 48.1402C64.7647 48.6348 64.3552 49.0591 63.8717 49.3854L51.2677 57.8931C49.5069 59.0816 47.2007 59.0816 45.4399 57.8931L32.836 49.3854C31.2506 48.3153 30.6358 46.3453 31.2128 44.6154L45.4648 54.1145C47.1049 55.2079 49.2106 55.2762 50.9089 54.3195L51.2429 54.1145L65.4935 44.6143C65.8721 45.7521 65.7591 47.0439 65.0739 48.1402ZM65.0739 54.911C64.7647 55.4057 64.3552 55.8299 63.8717 56.1562L51.2677 64.6639C49.5069 65.8525 47.2007 65.8525 45.4399 64.6639L32.836 56.1562C31.2506 55.0861 30.6358 53.1161 31.2128 51.3862L45.4648 60.8853C47.1049 61.9787 49.2106 62.0471 50.9089 61.0903L51.2429 60.8853L65.4935 51.3851C65.8721 52.523 65.7591 53.8147 65.0739 54.911Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscSvg2);
export default __webpack_public_path__ + "static/media/DiscSVG2.96e77582d9d903f75e80c1555b72c2ea.svg";
export { ForwardRef as ReactComponent };